<template>
    <div>
        <v-card class="mt-8 mx-8 pa-4">
            <v-card-actions class="text-left">
                <v-row>
                    <v-col cols="12" class="text-left">
                        <v-icon class="back-link-icon" x-large @click="$router.push('/courses/index')">mdi-arrow-left
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-actions>
            <v-card-title>ساخت دوره جدید</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field color="black" v-model="course.title" label="عنوان"></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-select label="دسته بندی" :items="categories" item-text="label" item-value="id"
                                  color="black" v-model="course.category_id">
                        </v-select>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field label="زیر نویس" color="black" v-model="course.sub_title"></v-text-field>
                    </v-col>

                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field color="black" type="number" v-model="course.price" label="مبلغ دوره"
                                      hint=" به تومان وارد شود."></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field color="black" type="number" v-model="course.duration" label="مدت زمان دوره"
                                      hint="به ماه وارد شود."></v-text-field>
                    </v-col>

                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field label="درصد تخفیف" hint="عددی بین صفر تا صد وارد شود" color="black"
                                      v-model="course.discount"></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field label="درصد تخفیف خرید نقدی دوره (بدون اقساط)" hint="عددی بین صفر تا صد وارد شود"
                                      color="black" v-model="course.total_buy_discount"></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field label="تعداد اقساط دوره" hint="تعداد ماه های دوره باید بر این عدد بخش پذیر باشد"
                                      color="black" v-model="course.installment_count"></v-text-field>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field label="بنر"
                                      @click="bannerFileDialog = true" prepend-icon="mdi-plus"
                                      color="black"
                                      v-model="course.banner"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-autocomplete :items="covers" item-text="tag" item-value="id" v-model="course.cover_id"
                                        label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
                    </v-col>

                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-select label="وضعیت نمایش"
                                  :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                                  color="black" v-model="course.visibility">
                        </v-select>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-select label="وضعیت نمایش در صفحه اصلی"
                                  :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                                  color="black" v-model="course.show_index">
                        </v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox
                                v-model="course.is_dictation_course"
                                color="black"
                                label="دوره مخصوص دیکته">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="6" md="3" lg="3" sm="6" v-if="course.is_dictation_course">
                        <v-text-field
                                color="black"
                                type="number"
                                min="0"
                                max="100"
                                v-model="course.dictation_unlock_percentage"
                                label="درصد باز شدن خودکار درس بعدی (0 تا 100)">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea color="black" v-model="course.description" label="توضیحات دوره"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea color="black" v-model="course.details" hint="در داشبورد کاربر نمایش داده می شود."
                                    label="اطلاعات دوره"></v-textarea>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="bannerFileDialog" max-width="50vw">
            <drag-and-drop module="course" ref="image-uploader" @closeUploadFileDialog="bannerFileDialog = false"
                           @changeFile="course.banner = $event"></drag-and-drop>
        </v-dialog>
    </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
    name: "CourseCreate",
    components: {DragAndDrop},
    data() {
        return {
            covers: [],
            bannerFileDialog: false,
            categories: [],
            course: {
                category_id: null,
                title: null,
                sub_title: null,
                description: null,
                price: null,
                duration: null,
                discount: null,
                total_buy_discount: null,
                installment_count: null,
                banner: null,
                cover_id: null,
                visibility: null,
                show_index: null,
                is_dictation_course: false,
                dictation_unlock_percentage: null,
                details: null
            }
        }
    },
    mounted() {
        this.getCategories()
        this.getCovers()
    },
    methods: {
        getCovers() {
            window.axios.get('file-manager/cover/index?type=course_cover&per_page=10000').then((res) => {
                this.covers = res.data.data.data
            })
        },
        store() {
            window.axios.post('course/crud/create', this.course).then(() => {
                this.openSnackbar("دوره جدید با موفقیت ساخته شد.", 'success')
            }).catch((err) => {
                if (err.response.status === 422) {
                    this.showValidationErrors(err, '#F1416C')
                } else if (err.response.status === 400) {
                    this.openSnackbar(err.response.data.message, '#F1416C')
                }
            })
        },
        clear() {
            this.course = {
                category_id: null,
                title: null,
                sub_title: null,
                description: null,
                price: null,
                duration: null,
                discount: null,
                total_buy_discount: null,
                installment_count: null,
                installment_duration: null,
                installment_price: null,
                banner: null,
                cover: null,
                visibility: null,
                show_index: null,
                is_dictation_course: false,
                dictation_unlock_percentage: null
            }
        },
        getCategories() {
            window.axios.get('category/index?per_page=1000&type=course').then((res) => {
                this.categories = res.data.data.data
            })
        },
    }
}
</script>

<style>
.back-link-icon {
    color: #413e3e !important;
}

.back-link-icon:hover {
    color: orangered !important;
}

.normal-font-btn {
    letter-spacing: normal !important;
}
</style>
